<template>
  <Header></Header>
  <Banner></Banner>
  <Choose></Choose>
  <Quote @prendre="affecter" ></Quote>
  <Others></Others>
  <Contact @prendre="affecter" ></Contact>
  <Footer></Footer>
</template>

<script>
import Header from "./components/Header.vue";
import Banner from "./components/Banner.vue";
import Choose from "./components/Choose.vue";
import Quote from "./components/Quote.vue";
import Others from "./components/Others.vue";
import Contact from "./components/Contact.vue";
import Footer from "./components/Footer.vue";
export default {
  name: "App",
  data() {
    return {
      message: "Bonjour",
    };
  },
  components: {
    Header,
    Banner,
    Choose,
    Quote,
    Others,
    Contact,
    Footer,
  },
  methods: {
    affecter(texte){
      this.message = texte;
    },
  },
};
</script>